import { render } from "./work-in-progress.vue?vue&type=template&id=7da4a7fa&scoped=true&ts=true"
import script from "./work-in-progress.vue?vue&type=script&lang=ts"
export * from "./work-in-progress.vue?vue&type=script&lang=ts"

import "./work-in-progress.vue?vue&type=style&index=0&id=7da4a7fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da4a7fa"]])

export default __exports__